import React from "react";
import { Form, Col } from "react-bootstrap";
import FilterationBarContainer from "../../../components/FilterationBarContainer";
import CustomReactSelect from "../../../components/CustomReactSelect";

const FilterationBar = (props) => {
  const {
    supervisorsEmpList,
    selectedSupEmp,
    onSupEmpChange,
    leaveTypes,
    selectedLeaveType,
    onLeaveTypeChange,
  } = props;

  return (
    <FilterationBarContainer>
      <Col lg={4} className="mb-1">
        <Form.Group className="input-field">
          <Form.Label className="label">Employee</Form.Label>
          <Col>
            <CustomReactSelect
              options={supervisorsEmpList}
              value={selectedSupEmp}
              onChange={(value) => onSupEmpChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
      <Col lg={4}>
        <Form.Group className="input-field">
          <Form.Label className="label">Leave Type</Form.Label>
          <Col>
            <CustomReactSelect
              options={leaveTypes}
              value={selectedLeaveType}
              onChange={(value) => onLeaveTypeChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
    </FilterationBarContainer>
  );
};

export default FilterationBar;
